import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface UserProfile {
  id: number
  name: string
  email: string
  phone: string
  businessName?: string
  role_id: number
  role_name?: string
  status: number
  countryCode?: string
}

export function useCurrentUser() {
  return useQuery<UserProfile>({
    queryKey: ['me'],
    queryFn: () =>
      api.get<{ data: UserProfile }>('/api/v1/me').then((r) => r.data),
    staleTime: 10 * 60_000,
  })
}
